import { useApolloClient } from '@apollo/client';
import { Box } from '@bechtel/gds';
import { UiTextEnum } from '@bechtel/sr-types';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { EMULATED_USER_ID, MultiLingualText } from '~/components';

export const EmulateAction: FC<{ toggle }> = ({ toggle }) => {
  const navigate = useNavigate();
  const client = useApolloClient();

  const onEmulate = async () => {
    const userBun = prompt(
      `${'Enter User Bun to Emulate:'}${'\n'}${'Enter blank to remove emulation.'}`,
      ''
    )?.toLowerCase();
    if (userBun == null) return;
    window.sessionStorage.setItem(EMULATED_USER_ID, userBun.trim());
    navigate('/', { replace: true });

    await client.resetStore();
  };

  return (
    <Box
      flexGrow={{ sm: 1 }}
      onClick={() => {
        if (toggle) toggle();
        // TODO: use it inside useEffect
        setTimeout(() => {
          onEmulate();
        }, 0);
      }}
    >
      <MultiLingualText
        size="400"
        color="black"
        family="openSansCondensed"
        textKey={UiTextEnum.EMULATE}
      ></MultiLingualText>
    </Box>
  );
};
